export var EventAction;
(function (EventAction) {
    EventAction["OpenRealTimeSideBar"] = "OpenRealTimeSideBar";
})(EventAction || (EventAction = {}));
